import { render, staticRenderFns } from "./PrintComponent.vue?vue&type=template&id=70fb6adb&"
import script from "./PrintComponent.vue?vue&type=script&lang=js&"
export * from "./PrintComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports